import './FinancialAssistanceForm.scss';

import { useFormikContext } from 'formik';
import { Button, Form } from 'react-bootstrap';

import { Turnstile } from '@components/Turnstile/Turnstile';
import { IFinancialAssistanceForm } from '@customTypes/requisition';

import AttestationFieldSet from './AttestationFieldSet';
import ContactInformationFieldSet from './ContactInformationFieldSet';
import HouseholdInformation from './household-information/HouseholdInformation';
import PatientInformationFieldSet from './PatientInformationFieldSet';

const FinancialAssistanceForm = () => {
  const { isValid, isSubmitting, handleSubmit } = useFormikContext<IFinancialAssistanceForm>();

  return (
    <Form className='d-flex flex-column gap-4 financial-assistance-form' noValidate onSubmit={handleSubmit}>
      <HouseholdInformation />
      <PatientInformationFieldSet />
      <ContactInformationFieldSet />
      <AttestationFieldSet />

      <Turnstile execution='execute' />

      <Button type='submit' className='btn btn-primary btn-submit' disabled={isSubmitting || !isValid}>
        Submit
      </Button>
    </Form>
  );
};

export default FinancialAssistanceForm;
